import organizations from "@/apis/coreIAM/organizations"
import { organizationsTypes } from "@/store/mutationTypes"

export default {
    state: {
        users: [],
        admins: [],
        editors: [],
        viewers: [],
        fetchAllUsers: {
            pending: false,
            error: null,
        },
        createOneUser: {
            pending: false,
            error: null,
        },
        removeOneUser: {
            pending: false,
            error: null,
        },
        fetchAllAdmins: {
            pending: false,
            error: null,
        },
        addAdmin: {
            pending: false,
            error: null,
        },
        removeAdmin: {
            pending: false,
            error: null,
        },
        fetchAllEditors: {
            pending: false,
            error: null,
        },
        addEditor: {
            pending: false,
            error: null,
        },
        removeEditor: {
            pending: false,
            error: null,
        },
        fetchAllViewers: {
            pending: false,
            error: null,
        },
        addViewer: {
            pending: false,
            error: null,
        },
        removeViewer: {
            pending: false,
            error: null,
        },
    },
    mutations: {
        [organizationsTypes.FETCH_ALL_USERS_REQUEST]: function (state) {
            state.fetchAllUsers.pending = true;
        },
        [organizationsTypes.FETCH_ALL_USERS_SUCCESS]: function (state, users) {
            state.users = users;
            state.fetchAllUsers.error = null;
            state.fetchAllUsers.pending = false
        },
        [organizationsTypes.FETCH_ALL_USERS_FAILURE]: function (state, error) {
            state.fetchAllUsers.error = error;
            state.fetchAllUsers.pending = false;
        },
        [organizationsTypes.CREATE_USER_REQUEST]: function (state) {
            state.createOneUser.pending = true;
        },
        [organizationsTypes.CREATE_USER_SUCCESS]: function (state) {
            state.createOneUser.error = null;
            state.createOneUser.pending = false
        },
        [organizationsTypes.CREATE_USER_FAILURE]: function (state, error) {
            state.createOneUser.error = error;
            state.createOneUser.pending = false;
        },
        [organizationsTypes.REMOVE_USER_REQUEST]: function (state) {
            state.removeOneUser.pending = true;
        },
        [organizationsTypes.REMOVE_USER_SUCCESS]: function (state) {
            state.removeOneUser.error = null;
            state.removeOneUser.pending = false
        },
        [organizationsTypes.REMOVE_USER_FAILURE]: function (state, error) {
            state.removeOneUser.error = error;
            state.removeOneUser.pending = false;
        },
        [organizationsTypes.FETCH_ALL_ADMIN_USERS_REQUEST]: function (state) {
            state.fetchAllAdmins.pending = true;
        },
        [organizationsTypes.FETCH_ALL_ADMIN_USERS_SUCCESS]: function (state, admins) {
            state.admins = admins;
            state.fetchAllAdmins.error = null;
            state.fetchAllAdmins.pending = false
        },
        [organizationsTypes.FETCH_ALL_ADMIN_USERS_FAILURE]: function (state, error) {
            state.fetchAllAdmins.error = error;
            state.fetchAllAdmins.pending = false;
        },
        [organizationsTypes.ADD_ADMIN_TO_ORGANIZATION_REQUEST]: function (state) {
            state.addAdmin.pending = true;
        },
        [organizationsTypes.ADD_ADMIN_TO_ORGANIZATION_SUCCESS]: function (state) {
            state.addAdmin.error = null;
            state.addAdmin.pending = false
        },
        [organizationsTypes.ADD_ADMIN_TO_ORGANIZATION_FAILURE]: function (state, error) {
            state.addAdmin.error = error;
            state.addAdmin.pending = false;
        },
        [organizationsTypes.REMOVE_ADMIN_FROM_ORGANIZATION_REQUEST]: function (state) {
            state.removeAdmin.pending = true;
        },
        [organizationsTypes.REMOVE_ADMIN_FROM_ORGANIZATION_SUCCESS]: function (state) {
            state.removeAdmin.error = null;
            state.removeAdmin.pending = false
        },
        [organizationsTypes.REMOVE_ADMIN_FROM_ORGANIZATION_FAILURE]: function (state, error) {
            state.removeAdmin.error = error;
            state.removeAdmin.pending = false;
        },
        [organizationsTypes.FETCH_ALL_EDITOR_USERS_REQUEST]: function (state) {
            state.fetchAllEditors.pending = true;
        },
        [organizationsTypes.FETCH_ALL_EDITOR_USERS_SUCCESS]: function (state, editors) {
            state.editors = editors;
            state.fetchAllEditors.error = null;
            state.fetchAllEditors.pending = false
        },
        [organizationsTypes.FETCH_ALL_EDITOR_USERS_FAILURE]: function (state, error) {
            state.fetchAllEditors.error = error;
            state.fetchAllEditors.pending = false;
        },
        [organizationsTypes.ADD_EDITOR_TO_ORGANIZATION_REQUEST]: function (state) {
            state.addEditor.pending = true;
        },
        [organizationsTypes.ADD_EDITOR_TO_ORGANIZATION_SUCCESS]: function (state) {
            state.addEditor.error = null;
            state.addEditor.pending = false
        },
        [organizationsTypes.ADD_EDITOR_TO_ORGANIZATION_FAILURE]: function (state, error) {
            state.addEditor.error = error;
            state.addEditor.pending = false;
        },
        [organizationsTypes.REMOVE_EDITOR_FROM_ORGANIZATION_REQUEST]: function (state) {
            state.removeEditor.pending = true;
        },
        [organizationsTypes.REMOVE_EDITOR_FROM_ORGANIZATION_SUCCESS]: function (state) {
            state.removeEditor.error = null;
            state.removeEditor.pending = false
        },
        [organizationsTypes.REMOVE_EDITOR_FROM_ORGANIZATION_FAILURE]: function (state, error) {
            state.removeEditor.error = error;
            state.removeEditor.pending = false;
        },
        [organizationsTypes.FETCH_ALL_VIEWER_USERS_REQUEST]: function (state) {
            state.fetchAllViewers.pending = true;
        },
        [organizationsTypes.FETCH_ALL_VIEWER_USERS_SUCCESS]: function (state, viewers) {
            state.viewers = viewers;
            state.fetchAllViewers.error = null;
            state.fetchAllViewers.pending = false
        },
        [organizationsTypes.FETCH_ALL_VIEWER_USERS_FAILURE]: function (state, error) {
            state.fetchAllViewers.error = error;
            state.fetchAllViewers.pending = false;
        },
        [organizationsTypes.ADD_VIEWER_TO_ORGANIZATION_REQUEST]: function (state) {
            state.addViewer.pending = true;
        },
        [organizationsTypes.ADD_VIEWER_TO_ORGANIZATION_SUCCESS]: function (state) {
            state.addViewer.error = null;
            state.addViewer.pending = false
        },
        [organizationsTypes.ADD_VIEWER_TO_ORGANIZATION_FAILURE]: function (state, error) {
            state.addViewer.error = error;
            state.addViewer.pending = false;
        },
        [organizationsTypes.REMOVE_VIEWER_FROM_ORGANIZATION_REQUEST]: function (state) {
            state.removeViewer.pending = true;
        },
        [organizationsTypes.REMOVE_VIEWER_FROM_ORGANIZATION_SUCCESS]: function (state) {
            state.removeViewer.error = null;
            state.removeViewer.pending = false
        },
        [organizationsTypes.REMOVE_VIEWER_FROM_ORGANIZATION_FAILURE]: function (state, error) {
            state.removeViewer.error = error;
            state.removeViewer.pending = false;
        },
    },
    actions: {
        async fetchAllUsers({ commit }, payload) {
            commit(organizationsTypes.FETCH_ALL_USERS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listOrganizationUsers(payload.organizationUuid)
                    .then((users) => {
                        commit(organizationsTypes.FETCH_ALL_USERS_SUCCESS, users.data)
                        resolve(users.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_USERS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOneUser({ commit }, payload) {
            commit(organizationsTypes.CREATE_USER_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .createOrganizationUser(
                        payload.organizationUuid,
                        payload.lastName,
                        payload.firstName,
                        payload.email,
                    )
                    .then((user) => {
                        commit(organizationsTypes.CREATE_USER_SUCCESS)
                        resolve(user.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.CREATE_USER_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeOneUser({ commit }, payload) {
            commit(organizationsTypes.REMOVE_USER_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeOrganizationUser(
                        payload.organizationUuid,
                        payload.userUuid,
                    )
                    .then((user) => {
                        commit(organizationsTypes.REMOVE_USER_SUCCESS)
                        resolve(user.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.REMOVE_USER_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllAdmins({ commit }, payload) {
            commit(organizationsTypes.FETCH_ALL_ADMIN_USERS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listAdminUsers(payload.organizationUuid)
                    .then((admins) => {
                        commit(organizationsTypes.FETCH_ALL_ADMIN_USERS_SUCCESS, admins.data)
                        resolve(admins.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_ADMIN_USERS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addAdmin({ commit }, payload) {
            commit(organizationsTypes.ADD_ADMIN_TO_ORGANIZATION_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addAdminToOrganization(payload.organizationUuid, payload.userUuid)
                    .then(() => {
                        commit(organizationsTypes.ADD_ADMIN_TO_ORGANIZATION_SUCCESS)
                        resolve()
                    }).catch((error) => {
                        commit(organizationsTypes.ADD_ADMIN_TO_ORGANIZATION_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeAdmin({ commit }, payload) {
            commit(organizationsTypes.REMOVE_ADMIN_FROM_ORGANIZATION_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeAdminFromOrganization(payload.organizationUuid, payload.userUuid)
                    .then(() => {
                        commit(organizationsTypes.REMOVE_ADMIN_FROM_ORGANIZATION_SUCCESS)
                        resolve()
                    }).catch((error) => {
                        commit(organizationsTypes.REMOVE_ADMIN_FROM_ORGANIZATION_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllEditors({ commit }, payload) {
            commit(organizationsTypes.FETCH_ALL_EDITOR_USERS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listEditorUsers(payload.organizationUuid)
                    .then((editors) => {
                        commit(organizationsTypes.FETCH_ALL_EDITOR_USERS_SUCCESS, editors.data)
                        resolve(editors.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_EDITOR_USERS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addEditor({ commit }, payload) {
            commit(organizationsTypes.ADD_EDITOR_TO_ORGANIZATION_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addEditorToOrganization(payload.organizationUuid, payload.userUuid)
                    .then(() => {
                        commit(organizationsTypes.ADD_EDITOR_TO_ORGANIZATION_SUCCESS)
                        resolve()
                    }).catch((error) => {
                        commit(organizationsTypes.ADD_EDITOR_TO_ORGANIZATION_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeEditor({ commit }, payload) {
            commit(organizationsTypes.REMOVE_EDITOR_FROM_ORGANIZATION_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeEditorFromOrganization(payload.organizationUuid, payload.userUuid)
                    .then(() => {
                        commit(organizationsTypes.REMOVE_EDITOR_FROM_ORGANIZATION_SUCCESS)
                        resolve()
                    }).catch((error) => {
                        commit(organizationsTypes.REMOVE_EDITOR_FROM_ORGANIZATION_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchAllViewers({ commit }, payload) {
            commit(organizationsTypes.FETCH_ALL_VIEWER_USERS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listViewerUsers(payload.organizationUuid)
                    .then((viewers) => {
                        commit(organizationsTypes.FETCH_ALL_VIEWER_USERS_SUCCESS, viewers.data)
                        resolve(viewers.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_VIEWER_USERS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addViewer({ commit }, payload) {
            commit(organizationsTypes.ADD_VIEWER_TO_ORGANIZATION_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addViewerToOrganization(payload.organizationUuid, payload.userUuid)
                    .then(() => {
                        commit(organizationsTypes.ADD_VIEWER_TO_ORGANIZATION_SUCCESS)
                        resolve()
                    }).catch((error) => {
                        commit(organizationsTypes.ADD_VIEWER_TO_ORGANIZATION_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async removeViewer({ commit }, payload) {
            commit(organizationsTypes.REMOVE_VIEWER_FROM_ORGANIZATION_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeViewerFromOrganization(payload.organizationUuid, payload.userUuid)
                    .then(() => {
                        commit(organizationsTypes.REMOVE_VIEWER_FROM_ORGANIZATION_SUCCESS)
                        resolve()
                    }).catch((error) => {
                        commit(organizationsTypes.REMOVE_VIEWER_FROM_ORGANIZATION_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async getOrganizationUser(_, payload) {
            return await organizations.getOrganizationUser(
                payload.organizationUuid, payload.userUuid
            )
        }
    }
}